import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import RichText from './RichText';
import { Heading } from 'grommet';

const StyledContentItem = styled.div``;

export const ContentItem = ({
  title,
  body,
  textColor,
  className,
  headingLevel,
}) => {
  return (
    <StyledContentItem className={className}>
      <Heading
        margin={{ bottom: '0.5rem' }}
        level={headingLevel}
        color={textColor}
      >
        {title}
      </Heading>
      <RichText textColor={textColor} richText={body} />
    </StyledContentItem>
  );
};

ContentItem.propTypes = {
  textColor: PropTypes.oneOf(['black', 'white']),
  headingLevel: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
};

ContentItem.defaultProps = {
  textColor: 'black',
  headingLevel: 4,
};
